(($) => {

	$.fn.lpCollapsibleContainer = function (options) {

		const defaults = {},
			config = $.extend({}, defaults, options);

		// Instantiate collapsible containers.
		return this.each(function () {

			const $collapsibleParent = $(this);

			// Allows any child element with class="lpcToggleCollapsible" to toggle collapse/expand state.
			$collapsibleParent
				.on('click', '.lpcToggleCollapsible', (e) => {

					$(this).trigger('lpCollapsible:toggle');
					e.stopPropagation();

				})
				.on('keyup', '.lpcToggleCollapsible', (e) => {

					const keycode = (e.keyCode ? e.keyCode : e.which);
					if(keycode === 13){

						$(this).trigger('lpCollapsible:toggle');
						e.stopPropagation();

					}
					
				})
				.on('lpCollapsible:expand', (e) => {

					e.stopPropagation();
					$('> .lpcCollapsible', $collapsibleParent).slideDown(undefined, () =>
						$(this).trigger('lpCollapsible:didExpand')
					);
					$(this).removeClass('collapsed');
					$(this).attr("aria-expanded", true);

				})
				.on('lpCollapsible:collapse', (e) => {

					e.stopPropagation();
					$('> .lpcCollapsible', $collapsibleParent).slideUp();
					$(this).addClass('collapsed');
					$(this).attr("aria-expanded", false);

				})
				.on('lpCollapsible:toggle', (e) => {

					e.stopPropagation();
					if ($(this).hasClass('collapsed')) {

						$(this).trigger('lpCollapsible:expand');
						return;

					}
					$(this).trigger('lpCollapsible:collapse');

				});

			// Allows any child element with class="lpcCollapseCollapsible" to collapse the collapsible element.
			$collapsibleParent.on('click', '.lpcCollapseCollapsible', (e) => {

				$(this).trigger('lpCollapsible:collapse');

			})
			.on('keyup', '.lpcCollapseCollapsible', (e) => {

				const keycode = (e.keyCode ? e.keyCode : e.which);
				if(keycode === 13){

					$(this).trigger('lpCollapsible:collapse');

				}

			})

			// Initial state for slideUp/Down
			if ($collapsibleParent.hasClass('collapsed')) {

				$('> .lpcCollapsible', $collapsibleParent).css('display', 'none');

			} else {

				$('> .lpcCollapsible', $collapsibleParent).css('display', 'block');

			}

		});

	};

})(jQuery);
